import { useTransactionStore } from './transactionsStore';
import { useCategoriesStore as useCoreCategories } from '@flows.cash/core';
import { supabase } from '@/lib/supabase';
// Export a hook that provides access to the core categories store
// and adds any web-specific functionality if needed
export const useCategoriesStore = () => {
  const coreStore = useCoreCategories();
  
  // Add any web-specific extensions or overrides here
  
  return {
    ...coreStore,
    
    // Example of a web-specific wrapper that uses the core functionality
    updateCategoryCounts: async () => {
      const { transactions } = useTransactionStore.getState();
      const { data: { session } } = await supabase.auth.getSession();
      
      if (session?.user?.id) {
        // Map transactions to the expected format with categoryId property
        const formattedTransactions = transactions.map(transaction => ({
          categoryId: transaction.category_id
        }));
        
        await coreStore.updateTransactionCounts(session.user.id, formattedTransactions);
      }
    }
  };
};

// Re-export types from the core package
export { type MainCategory, type SubCategory } from '@flows.cash/types';